import React from 'react';
import PropTypes from 'prop-types';
import { Button as BsButton } from 'react-bootstrap';

import withId from '../../decorators/withId';

const Button = ({
  children,
  bStyle,
  type,
  disabled,
  onClick,
  className,
  id,
  ariaLabel,
  isLoading,
}) => (
  <BsButton
    aria-label={ariaLabel}
    bsStyle={bStyle}
    type={type}
    disabled={disabled || isLoading}
    onClick={onClick}
    className={className}
    data-id={id}
  >
    { children }
    {isLoading && <span className="glyphicon glyphicon-refresh glyphicon-spinner" />}
  </BsButton>
);

Button.propTypes = {
  /** Button label */
  children: PropTypes.any,
  /** Button style */
  bStyle: PropTypes.oneOf(['default', 'primary', 'success', 'info', 'warning', 'danger', 'link']),
  /** Button type */
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  /** Disable button */
  disabled: PropTypes.bool,
  /** Loading spinner and disabling button */
  isLoading: PropTypes.bool,
  /** Gets called when the user clicks on the button */
  onClick: PropTypes.func.isRequired,
  /** _____ */
  ariaLabel: PropTypes.string,
  /** Custom class name */
  className: PropTypes.string,
  /** Passed to data-id prop on button component
   *  @ignore
   */
  id: PropTypes.string,
};

Button.defaultProps = {
  children: null,
  bStyle: 'default',
  type: 'button',
  disabled: false,
  isLoading: false,
  className: null,
  ariaLabel: null,
  id: null,
};

export const ButtonBase = Button;

export default withId('Button')(Button);
